import '@fancyapps/fancybox';
import 'slick-carousel';

import $ from 'jquery';

class CTAs {
	constructor($el) {
		// module vars declarations
		this.$el = $el;
		this.$cta = this.$el.find('.btn');
		this.iframeClass = 'iframe-container';
		this.videoYTIframeSel = 'iframe[src*="youtube"], iframe[src*="youtu.be"]';
		this.videoIframeSel = 'iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="vimeo.com"]';
		
		// methods initialization
		this.init();
	}

	init() {
		// modal
		this.fancyboxHandle();
	}


	fancyboxHandle() {
		
		const that = this;
		$(window).on('resize', function(){
			that.fbBoxUpdate();
		});

		// open modal from slider item
		this.$cta.off('click').on('click', function () {
			that.fbBoxInit($(this).data('target'));
			// scale iframe video to remove black bars
			//that.handleVideoAspect();
		});
	}

	fbBoxInit(target){
		var that = this;
		var $element = typeof target !=='undefined' ? this.$el.find('[data-id="'+ target + '"]').html() : false;
		var $content = $element ? $('<div class="fancybox-content-wysiwyg"/>').html($element) : false;

		if(!$content){
			return false;
		}

		$.fancybox.open({
			src	: $content,
			type : 'inline',
			opts : {
				baseClass: "fancybox-hero",
				afterLoad : function( $instance, $slide ) {
					const $iframe = $slide.$content.find('iframe');
					if($iframe.length > 0){
						// const $fbContent = $iframe.closest('.fancybox-content');
						$slide.$content.removeClass('fancybox-content-wysiwyg');
						// iframe preparations
						$iframe.each(function(){
							const $iframe = $(this);
							const iframeWidth = $iframe.length > 0 && typeof $iframe.attr('width')!=='undefined' && $.trim($iframe.attr('width'))!=='' ? $iframe.attr('width') : false;
							const iframeHeight = $iframe.length > 0 && typeof $iframe.attr('height')!=='undefined' && $.trim($iframe.attr('height'))!=='' ? $iframe.attr('height') : false;
							const newIframeWidth = iframeWidth && iframeHeight ? iframeWidth * 3 : false;
							const newIframeHeight = iframeWidth && iframeHeight ? iframeHeight * 3 : false;
							const aspectRatio = iframeWidth && iframeHeight ? iframeHeight/iframeWidth * 100 : false;
							$iframe.parent().addClass(that.iframeClass);
							
							if(iframeWidth && iframeHeight && aspectRatio){
								$iframe.css({'aspect-ratio': `${iframeWidth}/${iframeHeight}`});
								$iframe.parent().css({'padding-bottom':aspectRatio + '%'});
								$iframe.attr('width', newIframeWidth);
								$iframe.attr('height', newIframeHeight);
							}
							
						});

						// try autoplay
						const $videoIframe = $slide.$content.find('iframe[src*="youtube"], iframe[src*="vimeo"]').first();
						if ($videoIframe.length) {
							// Get the video's source URL
							const src = $videoIframe.attr('src');
							const separator = src.indexOf('?') !== -1 ? '&' : '?';
							// Append the autoplay parameter to the URL
							$videoIframe.attr('src', `${src}${separator}autoplay=1`);
						}

					}else{
						//$slide.$content.addClass('fancybox-content-wysiwyg');
					}					
				}
			}
		});
	}

	fbBoxUpdate() {
		if($('body').hasClass('fancybox-active')){
			$.fancybox.getInstance().update();
		}
	}

	handleIframeVideoScale(scrWidth, scrHeight) {
		$(this.$el.find(this.videoIframeSel)).css({
			transform: `translate(-50%,-50%) scale(${1 + scrHeight / scrWidth})`,
		});
	}

	handleVideoAspect() {
		if (this.$backgroundVideo && this.$iframe) {
			// add scale on load
			const { innerWidth, innerHeight } = window;
			this.handleIframeVideoScale(innerWidth, innerHeight);
			// add scale on resize
			$(window).on('resize', (e) => {
				const { innerWidth, innerHeight } = e.target;
				this.handleIframeVideoScale(innerWidth, innerHeight);
			});
		}
	}
}

export default CTAs;